import React from 'react';
import Heading from '../../../generic-components/Heading';
import { Avatar, AvatarSize } from '../../../DesignSystem/VendorProfile/Avatar';
import Button from '../../../generic-components/Button';
import { VendorInfo } from './VendorInfo';
import { STYLES } from '../consts';
import { IVendorModel } from '../../../pages/UpdateVendor/interfaces';
import i18next from '../../../i18n/i18n';

interface IProps {
  vendorList: IVendorModel[];
  onVendorSelected: (vendorId: string) => void;
  filteredKey: string;
  onCreateNewVendor: () => void;
}

export const VendorPicker = ({ vendorList, onVendorSelected, filteredKey, onCreateNewVendor }: IProps) =>
  (vendorList.length ? (
    <div className={STYLES.FLOAT_PICKER.WRAPPER}>
      {vendorList.map((vendor) => (
        <Button
          className=''
          onClick={() => onVendorSelected(vendor.supplierId || '')}
          id={`vendor-${vendor.supplierId}`}
          childElement={
            <div className={STYLES.FLOAT_PICKER.CHILDREN}>
              <Avatar name={vendor.name} id={vendor?.supplierId || ''} size={AvatarSize.LARGE} />
              <VendorInfo name={vendor.name} email={vendor?.email || ''} />
            </div>
          }
        />
      ))}
      <Button
        onClick={onCreateNewVendor}
        className={STYLES.FLOAT_PICKER.CREATE_VENDOR}
        title={i18next.t('MOVE_MONEY.STEPS.VENDOR_PICKER.ADD_NEW')}
        id='createNewVendor'
      />
    </div>
  ) : filteredKey ? (
    <div className={STYLES.FLOAT_PICKER.ZERO_STATE_WRAPPER}>
      <Heading title='No vendor found' className={STYLES.FLOAT_PICKER.ZERO_STATE_HEADER} />
      <Button
        onClick={onCreateNewVendor}
        className={STYLES.FLOAT_PICKER.ADD_NEW_VENDOR}
        title={`Add new vendor ${filteredKey ? `"${filteredKey}"` : ''}`}
        id='createNewVendorEmptyState'
      />
    </div>
  ) : (
    <div className='absolute z-50 gap-1 flex items-center bg-bw00 py-[12px] left-0 top-0 translate-y-[50px] w-full rounded-[8px] border border-bw03 shadow-bottomShadow fadeIn'>
      <Button
        onClick={onCreateNewVendor}
        className={STYLES.FLOAT_PICKER.CREATE_VENDOR}
        title={i18next.t('MOVE_MONEY.STEPS.VENDOR_PICKER.ADD_NEW')}
        id='createNewVendor'
      />
    </div>
  ));
